import BeerSlider from 'beerslider';

export default function(dom, opts) {
	let options = {
		"sliderSel": "#ba-slider",
		...opts
	};

	const selectSlider = dom.querySelector(options.sliderSel);

	function curtainEffectHandler(e) {
		window.requestAnimationFrame((timestamp) => {
			curtainEffect(e.pageX - picturesContainerLeft);
		});
	}

	selectSlider.addEventListener('mousedown', (e) => {
		//dom.classList.add('slider-moved');
	});

	selectSlider.addEventListener('mouseup', (e) => {
		//dom.classList.remove('slider-moved');
	})

}
